const r = {
  borderColor: "border-primary"
}, o = {
  borderColor: "border-brand"
};
export {
  o as focus,
  r as hover
};
